module.exports = __webpack_public_path__ + "static/media/notebookQuestion.f29aac8c.png";